export default __webpack_public_path__ + "media/images/client-logos/housing-65a31d49cfce5824c521c3656477733f.png";